import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Mic, Presentation } from "lucide-react";
import { defineModuleUi, from, unwrap, useOrg } from "@vixio/data";
import { formatDate, todayIso, lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const CatalogPage = lazyPage(() => import("./CatalogPage"), "CatalogPage");
const EvaluationPage = lazyPage(() => import("./EvaluationPage"), "EvaluationPage");
const TalkPage = lazyPage(() => import("./TalkPage"), "TalkPage");
const TalksPage = lazyPage(() => import("./TalksPage"), "TalksPage");

function NextTalksWidget() {
  const org = useOrg();
  const q = useQuery({
    queryKey: ["talks", "widget", org.id],
    queryFn: () =>
      unwrap<Array<{ id: string; title: string; event_date: string; organizer_name: string | null; status: string }>>(
        from("talks", "v_talks").select("id, title, event_date, organizer_name, status").eq("org_id", org.id)
          .in("status", ["confirmed", "requested", "qualifying"]).gte("event_date", todayIso()).order("event_date").limit(5),
      ),
  });
  if (!q.data?.length) return <p className="muted">Nenhuma palestra à frente. <Link to="/entrega/palestras">Abrir palestras</Link></p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {q.data.map((t) => (
        <li key={t.id} className="vx-row" style={{ flexWrap: "nowrap", alignItems: "baseline" }}>
          <span className="num text-2" style={{ width: 92, flexShrink: 0 }}>{formatDate(t.event_date)}</span>
          <span style={{ minWidth: 0 }}>
            <Link to={`/entrega/palestras/${t.id}`}>{t.title}</Link>
            <span className="text-2"> · {t.organizer_name ?? ""}{t.status !== "confirmed" ? " (a confirmar)" : ""}</span>
          </span>
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "talks",
  title: "Palestras",
  domain: "delivery",
  icon: Mic,
  menu: [
    { path: "/entrega/palestras", label: "Palestras", minRole: "member", icon: Mic, order: 30, keywords: "palestra pedido proposta cachê sipat congresso gravação qr img avaliação" },
    { path: "/entrega/palestras/catalogo", label: "Ficha e catálogo", minRole: "member", icon: Presentation, order: 32, keywords: "one-sheet ficha de palestrante roteiro" },
  ],
  routes: [
    { path: "/entrega/palestras", element: <TalksPage />, minRole: "member" },
    { path: "/entrega/palestras/catalogo", element: <CatalogPage />, minRole: "member" },
    { path: "/entrega/palestras/:id", element: <TalkPage />, minRole: "member" },
  ],
  widgets: [{ key: "talks.next", title: "Próximas palestras", minRole: "member", span: 1, order: 32, element: NextTalksWidget }],
  publicRoutes: [{ path: "/avaliar/:token", element: <EvaluationPage /> }],
});
